export default {"src":"/_next/static/media/gi.4dd340c5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};